import { Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  alignItems: 'center'
});

export const icon = css({
  fill: Gray.Gray70
});
export const wideIcon = css({
  marginRight: '16px'
});
export const focusedIcon = css({
  fill: White.White10
});

export const title = css({
  color: '#FFFFFF',
  opacity: 0.5,
  fontSize: '23px'
});

export const focusedText = css({
  opacity: 1
});
